import Reveal from "@/components/feature/Reveal";
import { eventGroups } from "@/mocks/homeData";

const statusStyle: Record<string, string> = {
  持续更新: "bg-primary-100 text-primary-800",
  待核: "bg-accent-100 text-accent-900",
  已归档: "bg-secondary-100 text-secondary-900",
};

export default function EventGroups() {
  return (
    <section id="events" className="w-full px-4 md:px-10 py-16 md:py-24 bg-background-50">
      <Reveal className="max-w-2xl">
        <p className="font-label text-xs md:text-sm tracking-[0.24em] text-primary-600">按事件归组</p>
        <h2 className="mt-4 font-heading font-black text-2xl md:text-4xl text-foreground-950">
          同一件事的材料，放在同一个抽屉里
        </h2>
        <p className="mt-4 font-body text-sm md:text-base leading-7 text-foreground-600">
          事件编号是索引，不是结论。点开编号即可看到该事件下的全部聊天记录、截图与录音。
        </p>
      </Reveal>

      <Reveal delay={80} className="mt-10 md:mt-14">
        <div className="hidden lg:grid grid-cols-12 gap-6 px-6 pb-4 border-b border-background-300 font-label text-xs tracking-wide text-foreground-500">
          <span className="col-span-5">事件</span>
          <span className="col-span-3">材料构成</span>
          <span className="col-span-2">状态</span>
          <span className="col-span-2 text-right">最近更新</span>
        </div>

        <ul className="flex flex-col">
          {eventGroups.map((event, index) => (
            <li key={event.id} className="border-b border-background-200">
              <a
                href="#library"
                className="group grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6 items-center px-5 lg:px-6 py-6 hover:bg-background-100 transition-colors"
              >
                <div className="lg:col-span-5 flex items-start gap-4">
                  <span className="mt-0.5 w-9 h-9 flex-none flex items-center justify-center rounded-md bg-background-200 font-heading font-bold text-sm text-foreground-800">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="min-w-0">
                    <span className="font-label text-xs text-foreground-500">{event.id}</span>
                    <span className="block mt-1 font-heading font-bold text-base md:text-lg text-foreground-950 group-hover:text-primary-700 transition-colors">
                      {event.title}
                    </span>
                    <span className="block mt-1.5 font-body text-sm text-foreground-600">{event.angle}</span>
                  </span>
                </div>

                <div className="lg:col-span-3 flex flex-wrap items-center gap-x-5 gap-y-2">
                  <span className="inline-flex items-center gap-2 font-label text-sm text-foreground-700">
                    <i className="ri-chat-3-line text-base text-primary-500" aria-hidden="true"></i>
                    {event.chat}
                  </span>
                  <span className="inline-flex items-center gap-2 font-label text-sm text-foreground-700">
                    <i className="ri-image-2-line text-base text-primary-500" aria-hidden="true"></i>
                    {event.shot}
                  </span>
                  <span className="inline-flex items-center gap-2 font-label text-sm text-foreground-700">
                    <i className="ri-mic-line text-base text-primary-500" aria-hidden="true"></i>
                    {event.audio}
                  </span>
                </div>

                <div className="lg:col-span-2">
                  <span
                    className={`inline-flex items-center rounded-full px-3 py-1 font-label text-xs ${statusStyle[event.status] ?? "bg-background-200 text-foreground-700"}`}
                  >
                    {event.status}
                  </span>
                </div>

                <div className="lg:col-span-2 flex items-center justify-between lg:justify-end gap-3">
                  <span className="font-label text-sm text-foreground-500">{event.updatedAt}</span>
                  <i
                    className="ri-arrow-right-line text-lg text-foreground-400 group-hover:text-primary-600 group-hover:translate-x-1 transition-all"
                    aria-hidden="true"
                  ></i>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </Reveal>
    </section>
  );
}